import { Component, OnInit } from '@angular/core';
import { NoPermissionError } from '@antony/ng-ui';
import { NgIf } from '@angular/common';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss'],
  imports: [NgIf, MatCard, MatCardHeader, MatCardAvatar, MatIcon, MatCardTitle, MatCardSubtitle, TranslatePipe],
})
export class NoPermissionsComponent {
  noPermissionsError = new NoPermissionError();
}
